var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdtMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26549 5.09484V2.37983H1.58309V0H11.8732V2.41335H8.19076V5.09484H5.26549Z",
    fill: "#00A478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6428 3.75386C10.3249 3.75396 13.2842 4.49148 13.2842 5.39642C13.2838 6.3013 10.3247 7.03889 6.6428 7.03899C2.9606 7.03899 0.000316621 6.30136 0 5.39642C0 4.49142 2.9604 3.75386 6.6428 3.75386ZM6.6428 4.0223C2.78833 4.0223 0.790844 5.02772 0.549939 5.39642C0.790844 5.73161 2.78833 6.23512 6.6428 6.23512C10.5312 6.23506 12.4933 5.73159 12.7342 5.39642C12.4933 5.06126 10.4968 4.02243 6.6428 4.0223Z",
    fill: "#00A478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19078 5.93301V4.05596C7.70897 4.02245 7.19275 3.98893 6.67653 3.98893C6.19472 3.98893 5.74732 3.98893 5.29993 4.02245V5.89949C5.71291 5.89949 6.19472 5.93301 6.67653 5.93301C7.19275 5.96653 7.70897 5.96653 8.19078 5.93301Z",
    fill: "#00A478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6428 7.03899C6.16099 7.03899 5.7129 7.03925 5.2655 7.00573V12H8.15636V6.97221C7.67455 7.00573 7.15902 7.03899 6.6428 7.03899Z",
    fill: "#00A478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtMin);
export default __webpack_public_path__ + "static/media/usdt-min.e3754116854f39e47f5f777921ccd2fb.svg";
export { ForwardRef as ReactComponent };